import RiskDashboardPage from './RiskDashboardPage';
export { RiskDashboardPage };
export default RiskDashboardPage;
